<template>
    <!-- <div class="chartContainer">
        <div ref="consumerInsightPieChart" style="width: 100%; height: 500px;"></div>
        <div class="labelContainer text-center">
            <h5>{{ labels.value }}%</h5>
            <p>{{ labels.name }}</p>
        </div>
    </div> -->

    <div>
        <div class="chartContainer">
            <div ref="consumerInsightPieChart" style="width: 100%; height: 420px;"></div>
            <div class="labelContainer text-center">
                <h5>{{ labels.value }}%</h5>
                <p>{{ labels.name }}</p>
            </div>            
        </div>
        <div class="mt-3">
            <div class="row px-4">
                <div class="col-md-6 pb-2" v-for="item in displayData" :key="item.serial_number">
                    <div class="d-flex justify-content-between align-items-center">
                        <ul class="list-group list-group-horizontal align-items-center border-0">
                            <li class="list-group-item border-0 p-0 px-1 py-1">
                                <span class="badge-part" :style="{ backgroundColor: item.color }">&nbsp;</span>
                            </li>
                            <li class="list-group-item border-0 p-0 px-1 py-1 pt-2 ml-2" style="font-size: 12px">
                                {{ item.serial_number }}
                            </li>
                        </ul>
                        <div class="col-2 text-nowrap text-right" style="font-size: 12px">
                            {{ item.percent }} %
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    export default {
        data () {
            return {
                chart : null,
                label : null,

                dummyData : [
                    {kode:"mQ2xoPE1", value:21000},
                    {kode:"mQ2xoPE2", value:19000},
                    {kode:"mQ2xoPE3", value:17000},
                    {kode:"mQ2xoPE4", value:25000},
                    {kode:"mQ2xoPE5", value:13000},
                    {kode:"mQ2xoPE6", value:11000},
                    {kode:"mQ2xoPE7", value:2000},
                    {kode:"mQ2xoPE8", value:19000},
                ],
                labels : {
                    value : "0",
                    name : "-"
                }
            }
        },
        props : ['data'],
        computed: {
            displayData() {
                if (!this.data || this.data.length === 0) {
                    return [];
                }

                if (this.data.length <= 3) {
                    return this.data;
                }

                const top3 = this.data.slice(0, 3);

                const others = this.data.slice(3);
                let otherTotal = 0;
                for (let i = 0; i < others.length; i++) {
                    otherTotal += parseInt(others[i].total);
                }

                let total = 0;
                for (let i = 0; i < this.data.length; i++) {
                    total += parseInt(this.data[i].total);
                }

                const otherItem = {
                    serial_number: 'Other',
                    total: otherTotal,
                    percent: parseFloat((otherTotal / total * 100).toFixed(1)),
                    color: this.chart ? this.chart.colors.getIndex(3) : '#F2809F'
                };

                return [...top3, otherItem];
            }
        },
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            insertNewLine(str, maxLength) {
                // Check if the string's length is greater than the maximum length
                if (str.length > maxLength) {
                    // Insert '\n' at the maximum length position
                    return str.substring(0, maxLength) + '\n' + str.substring(maxLength);
                } else {
                    // If the string is shorter than or equal to the max length, return it as is
                    return str;
                }
            },
            getData () {
                let length = this.chart.data.length;

                if (this.data && this.data.length > 0) {
                    let chartData;
                    if (this.data.length <= 3) {
                        chartData = this.data;
                    } else {
                        const top3 = this.data.slice(0, 3);
                        const others = this.data.slice(3);
                        let otherTotal = 0;
                        for (let i = 0; i < others.length; i++) {
                            otherTotal += parseInt(others[i].total);
                        }
                        const otherItem = {
                            serial_number: 'Other',
                            total: otherTotal
                        };
                        chartData = [...top3, otherItem];
                    }

                    this.chart.addData(chartData, length);

                    let firstData = this.data[0]
                    let total = 0;
                    for (var i in this.data) total += parseInt(this.data[i].total);

                    this.labels.value = parseFloat((parseInt(firstData.total) / total * 100).toFixed(1));
                    this.labels.name = firstData.serial_number;

                    for (let j in this.data) {
                        this.data[j].percent = parseFloat((parseInt(this.data[j].total) / total * 100).toFixed(1));
                        this.data[j].color = this.chart.colors.getIndex(j);
                    }
                } else {
                    this.chart.addData([{serial_number : 'No Data', total : 1}], length);
                    this.labels.value = 0
                    this.labels.name = '-'
                }
            },
            createChart () {
                /* Chart code */
                // Themes begin
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.consumerInsightPieChart, am4charts.PieChart);

                this.chart.colors.list = [
                    am4core.color("#80B2F0"),
                    am4core.color("#80F2AC"),
                    am4core.color("#F2BC80"),
                    am4core.color("#F2809F"),
                ]

                // Add and configure Series
                let pieSeries = this.chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "total";
                pieSeries.dataFields.category = "serial_number";

                // Let's cut a hole in our Pie chart the size of 55% the radius
                this.chart.innerRadius = am4core.percent(50);

                // Put a thick white border around each Slice
                pieSeries.slices.template.stroke = am4core.color("#fff");
                pieSeries.slices.template.strokeWidth = 2;
                pieSeries.slices.template.strokeOpacity = 1;

                // Disable interactive cursor
                pieSeries.slices.template.cursorOverStyle = [
                    {
                    "property": "cursor",
                    "value": "default"
                    }
                ];

                pieSeries.slices.template.adapter.add("fill", (fill, target)=>{
                    return this.chart.colors.getIndex(target.dataItem.index);
                })

                pieSeries.alignLabels = false;
                // pieSeries.labels.template.bent = true;
                // pieSeries.labels.template.radius = 3;
                // pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.ticks.template.disabled = true;
                pieSeries.alignLabels = false;
                pieSeries.labels.template.text = "";
                pieSeries.labels.template.bent = true;
                pieSeries.labels.template.radius = am4core.percent(-25);
                pieSeries.labels.template.fill = am4core.color("#FFF");
                pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.labels.template.adapter.add("radius", (radius, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.percent(2.5);
                    } 
                    return radius;
                })

                pieSeries.labels.template.adapter.add("fill", (color, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.color("#000");
                    } 
                    return color;
                })

                let hoverState = pieSeries.slices.template.states.getKey("hover");
                hoverState.properties.scale = 1;
                hoverState.properties.shiftRadius = 0;

                pieSeries.slices.template.clickable = false;
                pieSeries.slices.template.hoverable = false;

                // Add a legend
                // this.chart.legend = new am4charts.Legend();
                // this.chart.legend.useDefaultMarker = true;
                // this.chart.legend.maxHeight = 100;
                // this.chart.legend.scrollable = true;
                // var marker = this.chart.legend.markers.template;
                // marker.cornerRadius(12, 12, 12, 12);
                // marker.width = 5;
                // marker.height = 20;


                // Add label
                // // this.chart.innerRadius = 100;
                // this.label = this.chart.seriesContainer.createChild(am4core.Label);
                // this.label.text = "Total\n0";
                // this.label.horizontalCenter = "middle";
                // this.label.verticalCenter = "middle";
                // this.label.textAlign = "middle";
                // this.label.fontSize = 20;

                // // Add font-weight style to make the text bolder
                // this.label.fontWeight = "bold"; // Add this line
                
                // let label2 = this.chart.seriesContainer.createChild(am4core.label);
                // label.text = "2000";
                // label.horizontalCenter = "middle";
                // label.verticalCenter = "bottom";
                // label.fontSize = 30;
            }   
        }
    }
</script>

<style scoped>
    .chartContainer {
        position: relative;
    }

    .labelContainer {
        position: absolute;
        /* top: 55%;
        left: 50%;
        transform: translate(-50%, -100%); */
        top: 61%;
        left: 50%;
        transform: translate(-50%, -100%);
    }

    .labelContainer h5 {
        font-size: 20px;
    }

    
    .labelContainer p {
        /* font-size: 0.75em; */
        font-size: 1em;
    }

    .badge-part {
        display: inline-block;
        padding: .35em .65em;
        font-size: .75em;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
    }
</style>